export enum ReceiptError {
  RECEIPT_WITH_INACTIVE_SERVICE_PROVIDER = 'RECEIPT_WITH_INACTIVE_SERVICE_PROVIDER',
}

export enum ReceiptBatchError {
  RECEIPT_BATCH_WITH_INACTIVE_SERVICE_PROVIDER = 'RECEIPT_BATCH_WITH_INACTIVE_SERVICE_PROVIDER',
  RECEIPT_BATCH_ALREADY_SUBMITTED = 'RECEIPT_BATCH_ALREADY_SUBMITTED',
}
